import { Breadcrumbs, Divider } from "@mui/material";
import { BreadCrumb } from "../BreadCrumb";

export default function GlimpseBreadCrumbs({ onSelected, active }) {
  const handleClick = (n) => {
    if (onSelected) onSelected(n);
  };

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<Divider sx={{ width: 36 }} />}
    >
      <BreadCrumb
        onClick={handleClick}
        active={active}
        number={1}
        label="Select Model Clip"
      />
      <BreadCrumb
        onClick={handleClick}
        active={active}
        number={2}
        label="Properties"
      />
      <BreadCrumb
        onClick={handleClick}
        active={active}
        number={3}
        label="Processing"
      />
    </Breadcrumbs>
  );
}
